"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var configuration_1 = require("./configuration");

var validation_1 = require("../../validation");

var DrainAccessoriesKeys;

(function (DrainAccessoriesKeys) {
  DrainAccessoriesKeys["Drain"] = "drain";
  DrainAccessoriesKeys["Siphon"] = "siphon";
})(DrainAccessoriesKeys = exports.DrainAccessoriesKeys || (exports.DrainAccessoriesKeys = {}));

var DrainAccessories =
/** @class */
function (_super) {
  __extends(DrainAccessories, _super);

  function DrainAccessories() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DrainAccessories.prototype.handle = function () {
    var _this = this;

    if (this.prevKey && this[this.prevKey] === null) {
      return null;
    }

    var data = {};
    Object.keys(DrainAccessoriesKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[DrainAccessoriesKeys[key]] = _this[DrainAccessoriesKeys[key]], _a));
    });
    return data;
  };

  DrainAccessories.prototype.handleDefaults = function () {
    var defaults = this.default;
    var data = this.handle(); // What I'm expecting to see is that it gets the defaults from the extended class, which is that it has limited allValues
    // Although wait, it's values I'm after... so I think validateDrain actually ignores our current values...

    if (data && this.trough) {
      // console.log('current default', defaults); 
      defaults = validation_1.validateDrain(data, defaults, this.trough, this);

      if (validation_1.isInstanceOfError(defaults)) {
        return defaults;
      } // console.log('validated drain defaults', defaults);


      defaults = validation_1.validateSiphon(data, defaults, this.trough, this);

      if (validation_1.isInstanceOfError(defaults)) {
        return defaults;
      }
    }

    return defaults;
  };

  Object.defineProperty(DrainAccessories.prototype, "drain", {
    get: function get() {
      if (!this.drainAccessories) {
        return this.getDefault(configuration_1.ConfigurationKeys.DrainAccessories, DrainAccessoriesKeys.Drain).default;
      }

      return this.drainAccessories.drain;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DrainAccessories.prototype, "siphon", {
    get: function get() {
      if (!this.drainAccessories) {
        return this.getDefault(configuration_1.ConfigurationKeys.DrainAccessories, DrainAccessoriesKeys.Siphon).default;
      }

      return this.drainAccessories.siphon;
    },
    enumerable: true,
    configurable: true
  });
  return DrainAccessories;
}(configuration_1.Configuration);

exports.DrainAccessories = DrainAccessories;